import { render, staticRenderFns } from "./NavigationAvatarMenu.vue?vue&type=template&id=dffb7950&scoped=true&"
import script from "./NavigationAvatarMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationAvatarMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationAvatarMenu.vue?vue&type=style&index=0&id=dffb7950&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffb7950",
  null
  
)

export default component.exports